import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const OrganizationOpportunityPage = lazy(() =>
  import("./OrganizationOpportunityPage").then((module) => ({ default: module.OrganizationOpportunityPage })),
);

export function OrganizationOpportunityAsync() {
  return (
    <Suspense fallback={<LoadingIndicatorFullPage open />}>
      <OrganizationOpportunityPage />
    </Suspense>
  );
}
